import React from 'react';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';
import { CommentEditorSubmitLabel } from './CommentEditor';

interface CommentInlineErrorProps {
  error?: string;
  type?: CommentEditorSubmitLabel;
}

const CommentErrors = {
  error_creating_comment_max_limit: 'Max comment limit of 1000 reached.',
  default: 'Check your internet connection or project access and try again.',
};

const CommentInlineError = (props: CommentInlineErrorProps) => {
  const { error, type = CommentEditorSubmitLabel.Save } = props;

  console.warn(`Unexpected error when trying to ${type} comment edit`, error);

  const { classes } = useStyles();
  const isSaveType = type === CommentEditorSubmitLabel.Save;

  const mappedErrorMessage = error
    ? CommentErrors[error as keyof typeof CommentErrors]
    : undefined;
  const errorMessage = mappedErrorMessage || error || CommentErrors.default;

  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <Icon type="exclamation02" htmlColor="black" fontSize="inherit" />
      </div>
      <div className={classes.textContainer}>
        <Typography variant="labelMd" bold>
          Failed to {isSaveType ? 'save edits' : 'send'}
        </Typography>
        <Typography variant="pSm">{errorMessage}</Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  icon: {
    display: 'flex',
    backgroundColor: palette.punch_300,
    borderRadius: '100%',
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: '2.667px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));

export default CommentInlineError;
